import { render, staticRenderFns } from "./UsersIndex.vue?vue&type=template&id=3b97ec93&scoped=true&"
import script from "./UsersIndex.vue?vue&type=script&lang=js&"
export * from "./UsersIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b97ec93",
  null
  
)

export default component.exports